<template>
  <div id="verify">
    <img :src="logoImg" style="width: 90vw;" />
    <div class="verify-box flex">
      <div class="flex block error-text" style="margin: 20px 0;" v-if="tipOne">{{tipOne}}</div>
      <template v-else>
        <div class="verify-phone flex block" style="margin-bottom: 10px;" v-if="!phoneError">
          <i class="el-icon-user"></i>
          <p>
            {{ name }}
            <span style="color: red;font-size: 14px;">{{phoneError}}</span>
          </p>
        </div>
        <div class="verify-phone flex block">
          <i class="el-icon-mobile-phone"></i>
          <p>
            {{ phone }}
            <span style="color: red;font-size: 14px;">{{phoneError}}</span>
          </p>
        </div>
        <div class="verify-code flex block">
          <el-input
            placeholder="请输入验证码"
            prefix-icon="el-icon-lock"
            @keyup.enter.native="submit()"
            v-model="code"
            @blur="scrollTop()"
          ></el-input>
          <el-button
            class="verify-btn"
            v-if="!bIsGetCode"
            @click="getCode"
            :disabled="disabled"
          >点击获取</el-button>
          <div class="verify-btn remain-time" v-else>{{ remainTime }} s</div>
        </div>
        <el-button class="verify-btn block" @click="submit" :disabled="disabled">进入</el-button>
        <!-- <div class="verify-phone login-in-pc" @click="goToPath('/scan','')"><p>在电脑上开庭</p></div> -->
        <div class="build-time">构建时间: {{buildTime}}</div>
      </template>
    </div>
  </div>
</template>

<script>
import client from '../utils/client';
import { verifyPhone } from '../utils/util';
import VerifyService from '../services/verify.service';

const verify = new VerifyService();

export default {
  data () {
    return {
      oName: '',
      phone: '',
      code: '',
      remainTime: verify.maxTime, //剩余时间
      bIsGetCode: !!verify.timer,
      query: {},
      disabled: true,
      tipOne: '',
      phoneError: '',
      name: '',
      role: '',
      logoImg: '',
      // buildTime: ''
      buildTime: BUILDTIME
    };
  },
  watch: {
    remainTime (val, oval) {
      if (val == 0) {
        this.remainTime = verify.maxTime
        verify.subscribe(res => {
          //绑定倒计时处理函数
          this.remainTime = res;
          if (res <= 0) {
            this.bIsGetCode = false;
          }
        });
      }
    }
  },
  mounted () {
    let query = this.$route.query;
    if (query && query.phone && query.caseId && query.kaitingId && query.oId) {
      this.query = query;
      this.phone = query.phone;
      this.logoImg = `https://files.i-ac.cn/public/${query.oId}_title.JPG`;
      sessionStorage.setItem('oId', query.oId);
      sessionStorage.setItem('caseId', query.caseId);
      sessionStorage.setItem('kaitingId', query.kaitingId);
      sessionStorage.setItem('phone', query.phone);
      // sessionStorage.setItem('fileName', fileName);
      this.getRoom({ oId: query.oId, caseId: query.caseId, kaitingId: query.kaitingId });
      verify.subscribe(res => {
        //绑定倒计时处理函数
        this.remainTime = res;
        if (res <= 0) {
          this.bIsGetCode = false;
        }
      });
    } else if (sessionStorage.getItem('oId') && sessionStorage.getItem('phone')) {
      this.phone = sessionStorage.getItem('phone');
      verify.subscribe(res => {
        //绑定倒计时处理函数
        this.remainTime = res;
        if (res <= 0) {
          this.bIsGetCode = false;
        }
      });
    } else {
      this.$message.error('缺少参数，请检查链接！');
      this.$router.push('/error');
    }
  },
  methods: {
    submit () {
      client
        .generateIdToken({ phone: this.phone, code: this.code, oId: sessionStorage.getItem('oId') })
        .then(res => {
          if (res && res.token) {
            sessionStorage.setItem('idToken', res.token)
            verify.reset();
            this.goToPath('/rule');
            console.log('验证成功');
          } else {
            console.log('验证失败');
          }
        })
        .catch(data => {
          verify.reset();
          console.log('验证失败');
        });
    },
    getCode () {
      if (!verifyPhone(this.phone)) {
        this.$message.error('请检查号码是否有误！');
        return false;
      } else {
        this.bIsGetCode = true;
        client
          .sendSMSCode({ phone: this.phone })
          .then(res => {
            this.$message({
              message: '发送成功！',
              type: 'success'
            });
            verify.start();
          })
          .catch(data => {
            verify.reset();
            this.bIsGetCode = false;
          });
      }
    },
    getRoom (params) {
      client.getRoom(params)
        .then((res) => {
          if (res.status == -1) {
            this.tipOne = '开庭已结束';
            return false;
          } else {
            if (res.users && res.users.length) {
              sessionStorage.setItem('users', JSON.stringify(res.users));
              let users = res.users;
              let phone = users.map((item) => {
                if (this.phone == item.phone) {
                  this.name = item.name;
                  this.role = item.role;
                  sessionStorage.setItem('name', this.name);
                  sessionStorage.setItem('role', this.role);
                }
                return item.phone;
              });
              if (phone.indexOf(this.phone) == -1) {
                this.phoneError = '（ 该用户不存在！）';
                return false;
              }
            }
            this.disabled = false;
            this.phoneError = '';
            this.tipOne = '';
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    goToPath (path, query) {
      this.$router.push({
        path,
        query
      });
    },
    scrollTop () {
      var ua = window.navigator.userAgent;
      if (ua.indexOf('iPhone') > 0 || ua.indexOf('iPad') > 0) { //键盘收起页面空白问题
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
      }
    }
  }
};
</script>
<style lang="scss">
#verify {
  height: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  overflow-y: hidden;
  background-color: #fff;

  .verify-title {
    width: 458px;
    padding-bottom: 50px;
    align-items: flex-end;
    justify-content: center;

    .title-name {
      font-size: 34px;
      line-height: 34px;
      letter-spacing: 1px;
      color: #0496fd;
      height: 34px;
      border-right: 1px solid #999999;
      padding-right: 20px;
      margin-right: 20px;
    }

    .title-tip {
      font-size: 22px;
      color: #333333;
    }
  }

  .verify-box {
    width: 90vw;
    /*height: 360px;*/
    flex-direction: column;
    justify-content: center;
    align-items: center;
    overflow-y: hidden;

    h1 {
      box-sizing: border-box;
      color: #333333;
      font-size: 22px;
      text-indent: 15px;
      position: relative;
      margin-top: 40px;
      margin-bottom: 30px;
    }

    h1:before {
      width: 4px;
      height: 22px;
      background-color: #0285e2;
      content: '';
      display: block;
      position: absolute;
      top: 4px;
    }

    .block {
      width: 90vw;
      height: 44px;
      margin-bottom: 20px;
    }
    .error-text {
      color: red;
      text-align: center;
      font-size: 22px;
      justify-content: center;
    }
    .verify-phone {
      align-items: flex-end;
      font-size: 22px;
      color: #333333;

      .el-icon-mobile-phone {
        font-size: 18px;
        color: #0496fd;
        padding-bottom: 4px;
      }
      .el-icon-user {
        font-size: 22px;
        color: #0496fd;
        padding-bottom: 4px;
      }
      p {
        margin-left: 15px;
      }
    }

    .verify-code {
      .remain-time {
        width: 106px;
        line-height: 44px;
        text-align: center;
        font-size: 16px;
      }
    }

    /*.verify-note{*/
    /*    width: 106px;*/
    /*    height: 44px;*/
    /*    background-color: #0496fd;*/
    /*}*/
    .login-in-pc {
      font-size: 14px;
    }
  }

  /*修改input框样式*/
  .el-input__icon {
    color: #0496fd;
  }

  .el-input__inner {
    border-radius: 0;
    border: solid 1px #dddddd;
    background-color: #fbfbfb;
    border-right: none;
  }

  /*修改按钮样式*/
  .verify-btn {
    background-color: #0496fd;
    border-radius: 0;
    color: #ffffff;
    height: 40px;
  }

  .verify-btn:disabled {
    background-color: #cacaca;
  }
  .build-time {
    position: absolute;
    left: 15px;
    bottom: 15px;
    color: #0496fd;
  }
  .login-in-pc {
    text-align: right;
    width: 100%;
    color: #0496fd;
    p {
      display: inline-block;
      border-bottom: 1px solid #0496fd;
      padding-bottom: 2px;
      color: #0496fd;
    }
  }
}
</style>
